import React from 'react';
import CountryFlag from 'components/general/CountryFlag/CountryFlag';
import Skeleton from 'components/general/Skeleton/Skeleton';

const GeographySummarySkeleton: React.SFC = () => (
  <div className="geography-summary">
    <div className="geography-summary__flag">
      <CountryFlag />
    </div>
    <div className="geography-summary__title">
      <Skeleton width={[60, 120]} />
    </div>
  </div>
);

export default GeographySummarySkeleton;

